import React from "react";
import HeroSection from "./HeroSection";
import ProjectSection from "./ProjectSection";
import ContactForm from "../../components/ContactForm";

const Project = () => {
  return (
    <>
      <HeroSection />
      <ProjectSection />
      <ContactForm />
    </>
  );
};

export default Project;
